<template>
  <MainNavbar class="edu-fixed-nav" />
  <PageTitle :pageTitle="instructor?.name || 'Eğitmen'" mainTitle="Takım Üyesi Hakkında" />
  <InstructorDetails />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import PageTitle from "../components/Common/PageTitle.vue";
import InstructorDetails from "../components/InstructorDetails/InstructorDetails.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";
import teamData, { Instructor } from "../data/teamData";

export default defineComponent({
  name: "InstructorDetailsPage",
  components: {
    MainNavbar,
    PageTitle,
    InstructorDetails,
    MainFooter,
  },
  setup() {
    const route = useRoute();
    const id = Number(route.params.id);
    const instructor: Instructor | undefined = teamData.find((t) => t.id === id);

    return { instructor };
  },
});
</script>
